import React, { useState, useEffect } from 'react';

const API = 'https://talku.online';

const PROVIDERS = [
  {
    id: 'anthropic', name: 'Anthropic', url: 'console.anthropic.com',
    desc: 'Claude — razonamiento avanzado, comprensión de contexto y herramientas para agentes conversacionales.',
    keyPlaceholder: 'sk-ant-api03-...',
    keyHint: 'Encuéntrala en console.anthropic.com → API Keys',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="6" fill="#0a0a0a"/><path d="M14.603 7h2.397l-5 10h-2.397l5-10zm-5.206 0H7l5 10h2.397l-5-10z" fill="#fff"/></svg>,
  },
  {
    id: 'openai', name: 'OpenAI', url: 'platform.openai.com',
    desc: 'GPT — modelos de lenguaje versátiles con capacidades de razonamiento y generación de texto.',
    keyPlaceholder: 'sk-proj-...',
    keyHint: 'Encuéntrala en platform.openai.com → API Keys',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="6" fill="#0a0a0a"/><path d="M18.7 10.9c.3-1 .2-2-.3-2.9-.7-1.3-2.1-2-3.5-1.9-.5-.8-1.2-1.3-2.1-1.6-1.4-.4-2.9 0-3.9 1-.9-.3-1.9-.2-2.7.3-1.3.7-2 2.1-1.9 3.5-.8.5-1.3 1.2-1.6 2.1-.4 1.4 0 2.9 1 3.9-.3.9-.2 1.9.3 2.8.7 1.3 2.1 2 3.5 1.9.5.8 1.2 1.3 2.1 1.6 1.4.4 2.9 0 3.9-1 .9.3 1.9.2 2.7-.3 1.3-.7 2-2.1 1.9-3.5.8-.5 1.3-1.3 1.6-2.1.4-1.4 0-2.9-1-3.8zm-7 8.4c-.5 0-1-.1-1.4-.4l.1-.1 2.3-1.3c.1-.1.2-.2.2-.4v-3.2l1 .6v2.6c0 1.2-1 2.2-2.2 2.2zm-4.8-2c-.3-.4-.4-.9-.3-1.4l.1.1 2.3 1.3c.1.1.3.1.4 0l2.8-1.6v1.1l-2.3 1.4c-1.1.6-2.4.2-3-.9zm-.6-5.1c.3-.4.6-.8 1.1-1v.1l0 2.7c0 .2.1.3.2.4l2.8 1.6-1 .6-2.3-1.4c-1-.6-1.4-2-.8-3zm8.2 1.9l-2.8-1.6V11.4l2.4 1.4c.1.1.2.2.2.4l0 2.7c0-.1 0 0 0 0l.1.1c-.3.5-.6.8-1.1 1l.1-.1 0-2.6c0-.2-.1-.3-.2-.4l-2.8-1.6 1-.6 2.3 1.4 .8-.4zm1-1.9l-.1-.1-2.3-1.3c-.1-.1-.3-.1-.4 0l-2.8 1.6v-1.2l2.4-1.4c1.1-.6 2.4-.2 3 .9.3.4.4 1 .3 1.5zm-6 2l-1-.6v-2.6c0-1.2 1-2.2 2.2-2.2.5 0 1 .2 1.4.4l-.1.1-2.3 1.3c-.1.1-.2.2-.2.4v3.2zm.5-1.1l1.3-.7 1.3.7v1.5l-1.3.7-1.3-.7v-1.5z" fill="#fff"/></svg>,
  },
];

export default function AILab({ user }) {
  const authH = () => ({ 'Authorization': `Bearer ${user?.token || localStorage.getItem('talku_token') || ''}`, 'Content-Type': 'application/json' });

  const [configs, setConfigs] = useState({});
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(true);
  const [detail, setDetail] = useState(null);

  const [apiKey, setApiKey] = useState('');
  const [defModel, setDefModel] = useState('');
  const [agents, setAgents] = useState([]);
  const [testing, setTesting] = useState(false);
  const [testStatus, setTestStatus] = useState(null);
  const [saving, setSaving] = useState(false);

  const [showCreate, setShowCreate] = useState(false);
  const [cStep, setCStep] = useState(0);
  const [cTrigger, setCTrigger] = useState('');
  const [cName, setCName] = useState('');
  const [cDesc, setCDesc] = useState('');
  const [cPrompt, setCPrompt] = useState('');
  const [cTools, setCTools] = useState([]);
  const [cModel, setCModel] = useState('');

  const [editAgent, setEditAgent] = useState(null);

  const [playAgent, setPlayAgent] = useState(null);
  const [playMsg, setPlayMsg] = useState('');
  const [playResp, setPlayResp] = useState('');

  const [kbDocs, setKbDocs] = useState([]);
  const [kbEdit, setKbEdit] = useState(null);
  const [kbSaving, setKbSaving] = useState(false);
  const [playLoading, setPlayLoading] = useState(false);

  useEffect(() => { loadAll(); }, []);

  const loadAll = async () => {
    setLoading(true);
    try {
      const [cfgR, metaR, kbR] = await Promise.all([
        fetch(`${API}/ai/configs`, { headers: authH() }),
        fetch(`${API}/ai/metadata`, { headers: authH() }),
        fetch(`${API}/knowledge/`, { headers: authH() }),
      ]);
      setConfigs((await cfgR.json()).configs || {});
      setMeta(await metaR.json());
      setKbDocs(await kbR.json());
    } catch {}
    setLoading(false);
  };

  const saveKbDoc = async () => {
    if (!kbEdit || !kbEdit.title.trim() || !kbEdit.content.trim()) return;
    setKbSaving(true);
    try {
      if (kbEdit.id) {
        const r = await fetch(`${API}/knowledge/${kbEdit.id}`, { method: 'PUT', headers: authH(), body: JSON.stringify({ title: kbEdit.title, content: kbEdit.content, category: kbEdit.category || 'general' }) });
        if (r.ok) { setKbDocs(prev => prev.map(d => d.id === kbEdit.id ? { ...d, title: kbEdit.title, content: kbEdit.content, category: kbEdit.category } : d)); setKbEdit(null); }
      } else {
        const r = await fetch(`${API}/knowledge/`, { method: 'POST', headers: authH(), body: JSON.stringify({ title: kbEdit.title, content: kbEdit.content, category: kbEdit.category || 'general' }) });
        if (r.ok) { const d = await r.json(); setKbDocs(prev => [...prev, { ...d, content: kbEdit.content, active: true }]); setKbEdit(null); }
      }
    } catch {}
    setKbSaving(false);
  };

  const deleteKbDoc = async (id) => {
    if (!window.confirm('¿Eliminar este documento?')) return;
    try {
      const r = await fetch(`${API}/knowledge/${id}`, { method: 'DELETE', headers: authH() });
      if (r.ok) setKbDocs(prev => prev.filter(d => d.id !== id));
    } catch {}
  };

  const toggleKbDoc = async (doc) => {
    try {
      const r = await fetch(`${API}/knowledge/${doc.id}`, { method: 'PUT', headers: authH(), body: JSON.stringify({ active: !doc.active }) });
      if (r.ok) setKbDocs(prev => prev.map(d => d.id === doc.id ? { ...d, active: !d.active } : d));
    } catch {}
  };

  const openDetail = async (pid) => {
    setDetail(pid); setApiKey(''); setTestStatus(null);
    setDefModel(meta?.defaultModels?.[pid] || '');
    try {
      const r = await fetch(`${API}/ai/agents/${pid}`, { headers: authH() });
      setAgents((await r.json()).agents || []);
    } catch { setAgents([]); }
  };

  const saveConfig = async () => {
    if (!apiKey.trim() || !detail) return;
    setSaving(true);
    try {
      const r = await fetch(`${API}/ai/config/${detail}`, {
        method: 'POST', headers: authH(),
        body: JSON.stringify({ api_key: apiKey.trim(), default_model: defModel }),
      });
      if (r.ok) { const d = await r.json(); setConfigs(prev => ({ ...prev, [detail]: d.config })); setApiKey(''); setTestStatus(null); }
    } catch {}
    setSaving(false);
  };

  const toggleConfig = async (pid) => {
    try {
      const r = await fetch(`${API}/ai/config/${pid}/toggle`, { method: 'PUT', headers: authH() });
      if (r.ok) { const d = await r.json(); setConfigs(prev => ({ ...prev, [pid]: d.config })); }
    } catch {}
  };

  const testConfig = async () => {
    if (!detail) return;
    setTesting(true); setTestStatus(null);
    try {
      const r = await fetch(`${API}/ai/config/${detail}/test`, {
        method: 'POST', headers: authH(),
        body: JSON.stringify({ api_key: apiKey.trim(), default_model: defModel }),
      });
      setTestStatus(await r.json());
    } catch { setTestStatus({ ok: false, error: 'Error de conexión' }); }
    setTesting(false);
  };

  const resetCreate = () => { setShowCreate(false); setCStep(0); setCTrigger(''); setCName(''); setCDesc(''); setCPrompt(''); setCTools([]); setCModel(''); };

  const createAgent = async () => {
    if (!detail) return;
    const r = await fetch(`${API}/ai/agents/${detail}`, {
      method: 'POST', headers: authH(),
      body: JSON.stringify({ name: cName, provider: detail, description: cDesc, trigger_type: cTrigger, system_prompt: cPrompt, tools_enabled: cTools, model_override: cModel || null, priority: agents.length + 1 }),
    });
    if (r.ok) { const d = await r.json(); setAgents(prev => [...prev, d.agent]); resetCreate(); }
  };

  const toggleAgent = async (id, active) => {
    const r = await fetch(`${API}/ai/agents/detail/${id}`, { method: 'PUT', headers: authH(), body: JSON.stringify({ active: !active }) });
    if (r.ok) { const d = await r.json(); setAgents(prev => prev.map(a => a.id === id ? d.agent : a)); }
  };

  const deleteAgent = async (id) => {
    if (!window.confirm('¿Eliminar este agente?')) return;
    const r = await fetch(`${API}/ai/agents/detail/${id}`, { method: 'DELETE', headers: authH() });
    if (r.ok) setAgents(prev => prev.filter(a => a.id !== id));
  };

  const saveEdit = async () => {
    if (!editAgent) return;
    const r = await fetch(`${API}/ai/agents/detail/${editAgent.id}`, {
      method: 'PUT', headers: authH(),
      body: JSON.stringify({ name: editAgent.name, description: editAgent.description, trigger_type: editAgent.triggerType, system_prompt: editAgent.systemPrompt, tools_enabled: editAgent.toolsEnabled, model_override: editAgent.modelOverride || null }),
    });
    if (r.ok) { const d = await r.json(); setAgents(prev => prev.map(a => a.id === d.agent.id ? d.agent : a)); setEditAgent(null); }
  };

  const testAgentChat = async (agentId) => {
    if (!playMsg.trim()) return;
    setPlayLoading(true); setPlayResp('');
    try {
      const r = await fetch(`${API}/ai/agents/detail/${agentId}/test`, { method: 'POST', headers: authH(), body: JSON.stringify({ message: playMsg }) });
      const d = await r.json();
      setPlayResp(d.ok ? d.response : `Error: ${d.error}`);
    } catch { setPlayResp('Error de conexión'); }
    setPlayLoading(false);
  };

  const triggerOpts = meta?.triggers || [];
  const toolOpts = meta?.tools || [];
  const modelOpts = meta?.models || {};
  const promptTemplates = meta?.promptTemplates || {};
  const providerModels = detail ? (modelOpts[detail] || []) : [];
  const prov = PROVIDERS.find(p => p.id === detail);
  const provConfig = detail ? configs[detail] : null;

  if (loading) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#9ca3af' }}>Cargando...</div>;

  // ═══ DETAIL VIEW ═══
  if (detail && prov) {
    return (
      <div style={{ padding: '40px 48px 60px' }}>
        <div className="sett-section-header">
          <button className="sett-btn sett-btn-ghost" onClick={() => setDetail(null)} style={{ marginBottom: 16 }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="15 18 9 12 15 6"/></svg>
            Volver
          </button>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            {prov.icon}
            <div>
              <div className="sett-section-title">{prov.name}</div>
              <div className="sett-section-sub">{prov.desc}</div>
            </div>
          </div>
        </div>

        {/* API Key */}
        <div className="sett-card" style={{ padding: 28, marginBottom: 24 }}>
          <div style={{ fontSize: 16, fontWeight: 650, color: '#0a0a0a', marginBottom: 4 }}>Conexión API</div>
          <div style={{ fontSize: 13, color: '#9ca3af', marginBottom: 18 }}>
            {provConfig ? <span style={{ color: '#22c55e' }}>Conectada — {provConfig.api_key_masked}</span> : 'No configurada'}
          </div>
          <div style={{ display: 'flex', gap: 12, alignItems: 'end' }}>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: '#0a0a0a', marginBottom: 6 }}>API Key</div>
              <input className="sett-input" type="password" placeholder={prov.keyPlaceholder} value={apiKey} onChange={e => setApiKey(e.target.value)} style={{ fontFamily: 'monospace' }} />
              <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 4 }}>{prov.keyHint}</div>
            </div>
            <button className="sett-btn sett-btn-outline" onClick={testConfig} disabled={testing || (!apiKey.trim() && !provConfig)} style={{ height: 44 }}>{testing ? 'Verificando...' : 'Verificar'}</button>
            <button className="sett-btn sett-btn-primary" onClick={saveConfig} disabled={!apiKey.trim() || saving} style={{ height: 44 }}>{saving ? 'Guardando...' : 'Guardar'}</button>
          </div>
          {testStatus && (
            <div style={{ marginTop: 12, padding: '10px 16px', borderRadius: 12, fontSize: 13, fontWeight: 500, background: testStatus.ok ? '#ecfdf5' : '#fef2f2', color: testStatus.ok ? '#065f46' : '#991b1b', border: testStatus.ok ? '1px solid #a7f3d0' : '1px solid #fecaca' }}>
              {testStatus.ok ? `Conexión exitosa — modelo ${testStatus.model}` : `Error: ${testStatus.error}`}
            </div>
          )}
        </div>

        {/* Model */}
        <div className="sett-card" style={{ padding: 28, marginBottom: 24 }}>
          <div style={{ fontSize: 16, fontWeight: 650, color: '#0a0a0a', marginBottom: 16 }}>Modelo predeterminado</div>
          <div style={{ display: 'flex', gap: 12 }}>
            {providerModels.map(m => (
              <div key={m.id} onClick={() => setDefModel(m.id)} style={{ flex: 1, padding: '14px 18px', borderRadius: 14, cursor: 'pointer', border: defModel === m.id ? '2px solid #0a0a0a' : '1.5px solid #e8e8e6', background: defModel === m.id ? '#fafaf9' : '#fff', transition: 'all .15s' }}>
                <div style={{ fontSize: 14, fontWeight: 650, color: '#0a0a0a' }}>{m.label}</div>
                <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 3 }}>{m.desc}</div>
                <div style={{ fontSize: 11, color: '#c4c4c2', marginTop: 4 }}>{m.cost}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Agents */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
          <div>
            <div style={{ fontSize: 18, fontWeight: 700, color: '#0a0a0a', letterSpacing: '-.3px' }}>Agentes</div>
            <div style={{ fontSize: 13, color: '#9ca3af', marginTop: 2 }}>{agents.length} agente{agents.length !== 1 ? 's' : ''} con {prov.name}</div>
          </div>
          <button className="sett-btn sett-btn-primary" onClick={() => setShowCreate(true)} disabled={!provConfig}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            Crear agente
          </button>
        </div>

        {!provConfig && (
          <div className="sett-card" style={{ padding: '40px 24px', textAlign: 'center' }}>
            <div style={{ fontSize: 15, fontWeight: 600, color: '#0a0a0a', marginBottom: 6 }}>Conecta tu API primero</div>
            <div style={{ fontSize: 13, color: '#9ca3af' }}>Ingresa tu API key de {prov.name} para crear agentes</div>
          </div>
        )}

        {provConfig && agents.length === 0 && (
          <div className="sett-card" style={{ padding: '40px 24px', textAlign: 'center' }}>
            <div style={{ fontSize: 15, fontWeight: 600, color: '#0a0a0a', marginBottom: 6 }}>Sin agentes aún</div>
            <div style={{ fontSize: 13, color: '#9ca3af', marginBottom: 16 }}>Crea tu primer agente con {prov.name}</div>
            <button className="sett-btn sett-btn-primary" onClick={() => setShowCreate(true)}>Crear agente</button>
          </div>
        )}

        {agents.length > 0 && (
          <div className="sett-card" style={{ overflow: 'hidden' }}>
            {agents.map((a, i) => (
              <div key={a.id} style={{ padding: '16px 24px', display: 'flex', alignItems: 'center', gap: 14, borderTop: i ? '1px solid #f0f0ee' : 'none', transition: 'background .15s' }}
                onMouseEnter={e => e.currentTarget.style.background = '#fafaf9'} onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 14, fontWeight: 600, color: '#0a0a0a' }}>{a.name}</div>
                  <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 2 }}>{a.triggerLabel}</div>
                </div>
                {a.description && <div style={{ flex: 1, fontSize: 12, color: '#6b7280', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{a.description}</div>}
                <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexShrink: 0 }}>
                  <button className="sett-btn sett-btn-ghost" style={{ height: 34, padding: '0 14px', fontSize: 12 }} onClick={() => setEditAgent({...a})}>Editar</button>
                  <button className="sett-btn sett-btn-ghost" style={{ height: 34, padding: '0 14px', fontSize: 12 }} onClick={() => { setPlayAgent(a); setPlayMsg(''); setPlayResp(''); }}>Probar</button>
                  <button className="sett-btn sett-btn-danger" style={{ height: 34, padding: '0 10px', fontSize: 12 }} onClick={() => deleteAgent(a.id)}>
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                  </button>
                  <button onClick={() => toggleAgent(a.id, a.active)} style={{ position: 'relative', width: 44, height: 26, borderRadius: 13, border: 'none', cursor: 'pointer', transition: 'background .2s', background: a.active ? '#22c55e' : '#e5e5ea', flexShrink: 0 }}>
                    <span style={{ position: 'absolute', top: 2, left: a.active ? 20 : 2, width: 22, height: 22, borderRadius: '50%', background: '#fff', transition: 'left .2s', boxShadow: '0 1px 3px rgba(0,0,0,.2)' }}/>
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* MODAL: CREAR AGENTE */}
        {showCreate && (
          <div className="sett-modal-overlay" onClick={e => { if (e.target === e.currentTarget) resetCreate(); }}>
            <div className="sett-modal" style={{ width: 620, maxHeight: '90vh', overflow: 'auto' }}>
              <div style={{ padding: '24px 28px 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ fontSize: 20, fontWeight: 700, color: '#0a0a0a', letterSpacing: '-.3px' }}>Nuevo agente — {prov.name}</div>
                <button className="sett-btn sett-btn-ghost" style={{ width: 32, height: 32, padding: 0, borderRadius: '50%', justifyContent: 'center' }} onClick={resetCreate}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                </button>
              </div>
              <div style={{ padding: '20px 28px 28px' }}>
                <div style={{ display: 'flex', gap: 4, marginBottom: 24 }}>
                  {['Tipo','Perfil','Prompt','Tools','Resumen'].map((s,i) => (
                    <div key={s} style={{ flex: 1, height: 3, borderRadius: 2, transition: 'background .2s', background: cStep >= i ? '#0a0a0a' : '#e8e8e6' }}/>
                  ))}
                </div>

                {cStep === 0 && (
                  <div>
                    <div style={{ fontSize: 15, fontWeight: 650, color: '#0a0a0a', marginBottom: 14 }}>¿Cuándo debe responder este agente?</div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                      {triggerOpts.map(t => (
                        <div key={t.id} onClick={() => { setCTrigger(t.id); if (promptTemplates[t.id]) setCPrompt(promptTemplates[t.id]); }}
                          style={{ padding: '14px 18px', borderRadius: 14, cursor: 'pointer', transition: 'all .15s', border: cTrigger === t.id ? '2px solid #0a0a0a' : '1.5px solid #e8e8e6', background: cTrigger === t.id ? '#fafaf9' : '#fff' }}>
                          <div style={{ fontSize: 14, fontWeight: 600, color: '#0a0a0a' }}>{t.label}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {cStep === 1 && (
                  <div>
                    <div style={{ marginBottom: 18 }}>
                      <div style={{ fontSize: 12, fontWeight: 600, color: '#0a0a0a', marginBottom: 6 }}>Nombre del agente</div>
                      <input className="sett-input" placeholder="Ej: Bot Confirmación COD" value={cName} onChange={e => setCName(e.target.value)} />
                    </div>
                    <div>
                      <div style={{ fontSize: 12, fontWeight: 600, color: '#0a0a0a', marginBottom: 6 }}>Descripción (opcional)</div>
                      <input className="sett-input" placeholder="¿Qué hace este agente?" value={cDesc} onChange={e => setCDesc(e.target.value)} />
                    </div>
                  </div>
                )}

                {cStep === 2 && (
                  <div>
                    <div style={{ fontSize: 12, fontWeight: 600, color: '#0a0a0a', marginBottom: 6 }}>Instrucciones del agente (System Prompt)</div>
                    <div style={{ fontSize: 11, color: '#9ca3af', marginBottom: 10 }}>Usa {'{{tienda}}'} para insertar el nombre de la tienda</div>
                    <textarea className="sett-input" value={cPrompt} onChange={e => setCPrompt(e.target.value)} style={{ height: 'auto', minHeight: 240, resize: 'vertical', padding: 14, lineHeight: 1.5, fontSize: 13 }} />
                  </div>
                )}

                {cStep === 3 && (
                  <div>
                    <div style={{ fontSize: 15, fontWeight: 650, color: '#0a0a0a', marginBottom: 14 }}>¿Qué puede hacer este agente?</div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 24 }}>
                      {toolOpts.map(t => (
                        <div key={t.id} onClick={() => setCTools(prev => prev.includes(t.id) ? prev.filter(x=>x!==t.id) : [...prev, t.id])}
                          style={{ padding: '12px 16px', borderRadius: 12, cursor: 'pointer', transition: 'all .15s', border: cTools.includes(t.id) ? '2px solid #0a0a0a' : '1.5px solid #e8e8e6', background: cTools.includes(t.id) ? '#fafaf9' : '#fff', display: 'flex', alignItems: 'center', gap: 12 }}>
                          <div style={{ width: 18, height: 18, borderRadius: 5, flexShrink: 0, border: cTools.includes(t.id) ? '2px solid #0a0a0a' : '2px solid #d4d4d2', background: cTools.includes(t.id) ? '#0a0a0a' : '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            {cTools.includes(t.id) && <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>}
                          </div>
                          <div>
                            <div style={{ fontSize: 13, fontWeight: 600, color: '#0a0a0a' }}>{t.label}</div>
                            <div style={{ fontSize: 11, color: '#9ca3af' }}>{t.desc}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div style={{ fontSize: 12, fontWeight: 600, color: '#0a0a0a', marginBottom: 8 }}>Modelo</div>
                    <div style={{ display: 'flex', gap: 10 }}>
                      <div onClick={() => setCModel('')} style={{ flex: 1, padding: '10px 14px', borderRadius: 10, cursor: 'pointer', textAlign: 'center', border: !cModel ? '2px solid #0a0a0a' : '1.5px solid #e8e8e6', fontSize: 13, fontWeight: 600 }}>Predeterminado</div>
                      {providerModels.map(m => (
                        <div key={m.id} onClick={() => setCModel(m.id)} style={{ flex: 1, padding: '10px 14px', borderRadius: 10, cursor: 'pointer', textAlign: 'center', border: cModel === m.id ? '2px solid #0a0a0a' : '1.5px solid #e8e8e6', fontSize: 13, fontWeight: 600 }}>{m.label}</div>
                      ))}
                    </div>
                  </div>
                )}

                {cStep === 4 && (
                  <div>
                    <div style={{ fontSize: 15, fontWeight: 650, color: '#0a0a0a', marginBottom: 16 }}>Resumen</div>
                    <div style={{ background: '#f5f5f3', borderRadius: 14, padding: 20 }}>
                      {[{ l:'Nombre', v:cName },{ l:'Tipo', v:triggerOpts.find(t=>t.id===cTrigger)?.label },{ l:'Proveedor', v:prov.name },{ l:'Tools', v:cTools.map(t=>toolOpts.find(x=>x.id===t)?.label||t).join(', ')||'Ninguna' },{ l:'Modelo', v:cModel?providerModels.find(m=>m.id===cModel)?.label:'Predeterminado' }].map(r => (
                        <div key={r.l} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #e8e8e6' }}>
                          <span style={{ fontSize: 13, color: '#9ca3af' }}>{r.l}</span>
                          <span style={{ fontSize: 13, fontWeight: 600, color: '#0a0a0a' }}>{r.v}</span>
                        </div>
                      ))}
                      <div style={{ marginTop: 14, fontSize: 11, color: '#9ca3af', marginBottom: 4 }}>Prompt</div>
                      <div style={{ fontSize: 12, color: '#555', background: '#fff', padding: 12, borderRadius: 10, maxHeight: 100, overflow: 'auto', whiteSpace: 'pre-wrap', lineHeight: 1.4 }}>
                        {cPrompt.slice(0, 300)}{cPrompt.length > 300 ? '...' : ''}
                      </div>
                    </div>
                  </div>
                )}

                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 24 }}>
                  <button className="sett-btn sett-btn-ghost" onClick={() => cStep === 0 ? resetCreate() : setCStep(s => s - 1)}>{cStep === 0 ? 'Cancelar' : 'Atrás'}</button>
                  {cStep < 4
                    ? <button className="sett-btn sett-btn-primary" disabled={(cStep===0&&!cTrigger)||(cStep===1&&!cName.trim())||(cStep===2&&!cPrompt.trim())} onClick={() => setCStep(s=>s+1)}>Siguiente</button>
                    : <button className="sett-btn sett-btn-primary" onClick={createAgent}>Crear agente</button>}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* MODAL: EDITAR */}
        {editAgent && (
          <div className="sett-modal-overlay" onClick={e => { if (e.target === e.currentTarget) setEditAgent(null); }}>
            <div className="sett-modal" style={{ width: 580, maxHeight: '90vh', overflow: 'auto' }}>
              <div style={{ padding: '24px 28px 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ fontSize: 20, fontWeight: 700, color: '#0a0a0a' }}>Editar agente</div>
                <button className="sett-btn sett-btn-ghost" style={{ width: 32, height: 32, padding: 0, borderRadius: '50%', justifyContent: 'center' }} onClick={() => setEditAgent(null)}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                </button>
              </div>
              <div style={{ padding: '20px 28px 28px' }}>
                <div style={{ marginBottom: 16 }}>
                  <div style={{ fontSize: 12, fontWeight: 600, color: '#0a0a0a', marginBottom: 6 }}>Nombre</div>
                  <input className="sett-input" value={editAgent.name} onChange={e => setEditAgent({...editAgent, name: e.target.value})} />
                </div>
                <div style={{ marginBottom: 16 }}>
                  <div style={{ fontSize: 12, fontWeight: 600, color: '#0a0a0a', marginBottom: 6 }}>Descripción</div>
                  <input className="sett-input" value={editAgent.description} onChange={e => setEditAgent({...editAgent, description: e.target.value})} />
                </div>
                <div style={{ marginBottom: 16 }}>
                  <div style={{ fontSize: 12, fontWeight: 600, color: '#0a0a0a', marginBottom: 6 }}>Tipo de trigger</div>
                  <select className="sett-select" style={{ width: '100%' }} value={editAgent.triggerType} onChange={e => setEditAgent({...editAgent, triggerType: e.target.value})}>
                    {triggerOpts.map(t => <option key={t.id} value={t.id}>{t.label}</option>)}
                  </select>
                </div>
                <div style={{ marginBottom: 16 }}>
                  <div style={{ fontSize: 12, fontWeight: 600, color: '#0a0a0a', marginBottom: 6 }}>System Prompt</div>
                  <textarea className="sett-input" value={editAgent.systemPrompt} onChange={e => setEditAgent({...editAgent, systemPrompt: e.target.value})} style={{ height: 'auto', minHeight: 200, resize: 'vertical', padding: 14, lineHeight: 1.5, fontSize: 13 }} />
                </div>
                <div style={{ marginBottom: 20 }}>
                  <div style={{ fontSize: 12, fontWeight: 600, color: '#0a0a0a', marginBottom: 8 }}>Tools habilitadas</div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                    {toolOpts.map(t => (
                      <span key={t.id} onClick={() => { const cur=editAgent.toolsEnabled||[]; setEditAgent({...editAgent, toolsEnabled: cur.includes(t.id)?cur.filter(x=>x!==t.id):[...cur,t.id]}); }}
                        className="sett-tag" style={{ cursor: 'pointer', background: (editAgent.toolsEnabled||[]).includes(t.id)?'#0a0a0a':'#f0f0ee', color: (editAgent.toolsEnabled||[]).includes(t.id)?'#fff':'#374151' }}>{t.label}</span>
                    ))}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
                  <button className="sett-btn sett-btn-ghost" onClick={() => setEditAgent(null)}>Cancelar</button>
                  <button className="sett-btn sett-btn-primary" onClick={saveEdit}>Guardar cambios</button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* MODAL: PLAYGROUND */}
        {playAgent && (
          <div className="sett-modal-overlay" onClick={e => { if (e.target === e.currentTarget) setPlayAgent(null); }}>
            <div className="sett-modal" style={{ width: 560, maxHeight: '90vh', overflow: 'auto' }}>
              <div style={{ padding: '24px 28px 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div>
                  <div style={{ fontSize: 18, fontWeight: 700, color: '#0a0a0a' }}>Probar: {playAgent.name}</div>
                  <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 2 }}>{playAgent.triggerLabel}</div>
                </div>
                <button className="sett-btn sett-btn-ghost" style={{ width: 32, height: 32, padding: 0, borderRadius: '50%', justifyContent: 'center' }} onClick={() => setPlayAgent(null)}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                </button>
              </div>
              <div style={{ padding: '20px 28px 28px' }}>
                <div style={{ background: '#f5f5f3', borderRadius: 16, padding: 20, minHeight: 180, marginBottom: 14, display: 'flex', flexDirection: 'column', gap: 12 }}>
                  {!playResp && !playLoading && <div style={{ textAlign: 'center', color: '#c4c4c2', fontSize: 13, padding: '50px 0' }}>Escribe un mensaje para probar cómo responde</div>}
                  {playMsg && playResp && (
                    <>
                      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <div style={{ padding: '10px 16px', borderRadius: '14px 14px 4px 14px', background: '#0a0a0a', color: '#fff', fontSize: 13, maxWidth: '80%', lineHeight: 1.5 }}>{playMsg}</div>
                      </div>
                      <div style={{ display: 'flex' }}>
                        <div style={{ padding: '10px 16px', borderRadius: '14px 14px 14px 4px', background: '#fff', color: '#0a0a0a', fontSize: 13, maxWidth: '80%', lineHeight: 1.5, border: '1px solid #e8e8e6' }}>{playResp}</div>
                      </div>
                    </>
                  )}
                  {playLoading && <div style={{ display: 'flex' }}><div style={{ padding: '10px 16px', borderRadius: '14px 14px 14px 4px', background: '#fff', color: '#9ca3af', fontSize: 13, border: '1px solid #e8e8e6' }}>Pensando...</div></div>}
                </div>
                <div style={{ display: 'flex', gap: 10 }}>
                  <input className="sett-input" placeholder="Escribe un mensaje de prueba..." value={playMsg} onChange={e => setPlayMsg(e.target.value)} onKeyDown={e => { if (e.key === 'Enter' && !playLoading) testAgentChat(playAgent.id); }} />
                  <button className="sett-btn sett-btn-primary" style={{ height: 44, padding: '0 16px' }} onClick={() => testAgentChat(playAgent.id)} disabled={playLoading || !playMsg.trim()}>
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  // ═══ MAIN VIEW — PROVIDER CARDS ═══
  return (
    <div style={{ padding: '40px 48px 60px' }}>
      <div className="sett-section-header">
        <div className="sett-section-title">Laboratorio IA</div>
        <div className="sett-section-sub">Conecta tu proveedor de IA y crea agentes inteligentes</div>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 16 }}>
        {PROVIDERS.map(p => {
          const cfg = configs[p.id];
          return (
            <div key={p.id} className="sett-card sett-card-enter" style={{ padding: 24, display: 'flex', flexDirection: 'column' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
                {p.icon}
                <div>
                  <div style={{ fontSize: 15, fontWeight: 650, color: '#0a0a0a' }}>{p.name}</div>
                  <div style={{ fontSize: 11, color: '#9ca3af' }}>{p.url}</div>
                </div>
              </div>
              <div style={{ fontSize: 13, color: '#6b7280', lineHeight: 1.5, marginBottom: 18, flex: 1 }}>{p.desc}</div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <button className="sett-btn sett-btn-outline" style={{ height: 36, fontSize: 12 }} onClick={() => openDetail(p.id)}>Ver integración</button>
                {cfg ? (
                  <button onClick={() => toggleConfig(p.id)} style={{ position: 'relative', width: 44, height: 26, borderRadius: 13, border: 'none', cursor: 'pointer', transition: 'background .2s', background: cfg.active ? '#22c55e' : '#e5e5ea' }}>
                    <span style={{ position: 'absolute', top: 2, left: cfg.active ? 20 : 2, width: 22, height: 22, borderRadius: '50%', background: '#fff', transition: 'left .2s', boxShadow: '0 1px 3px rgba(0,0,0,.2)' }}/>
                  </button>
                ) : <span style={{ fontSize: 12, color: '#c4c4c2', fontWeight: 500 }}>No conectada</span>}
              </div>
            </div>
          );
        })}
      </div>

      {/* ═══ BASE DE CONOCIMIENTO ═══ */}
      <div style={{ marginTop: 48 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
          <div>
            <div style={{ fontSize: 18, fontWeight: 700, color: '#0a0a0a', letterSpacing: '-.3px' }}>Base de conocimiento</div>
            <div style={{ fontSize: 13, color: '#9ca3af', marginTop: 2 }}>Documentos que los agentes usan para responder — {kbDocs.length} documento{kbDocs.length !== 1 ? 's' : ''}</div>
          </div>
          <button className="sett-btn sett-btn-primary" onClick={() => setKbEdit({ title: '', content: '', category: 'general' })}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            Nuevo documento
          </button>
        </div>

        {kbDocs.length === 0 && (
          <div className="sett-card" style={{ padding: '40px 24px', textAlign: 'center' }}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#c4c4c2" strokeWidth="1.5" strokeLinecap="round" style={{ marginBottom: 12 }}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
            <div style={{ fontSize: 15, fontWeight: 600, color: '#0a0a0a', marginBottom: 6 }}>Sin documentos aún</div>
            <div style={{ fontSize: 13, color: '#9ca3af', marginBottom: 16 }}>Agrega políticas, preguntas frecuentes o información de productos</div>
            <button className="sett-btn sett-btn-primary" onClick={() => setKbEdit({ title: '', content: '', category: 'general' })}>Crear documento</button>
          </div>
        )}

        {kbDocs.length > 0 && (
          <div className="sett-card" style={{ overflow: 'hidden' }}>
            {kbDocs.map((d, i) => (
              <div key={d.id} style={{ padding: '16px 24px', display: 'flex', alignItems: 'center', gap: 14, borderTop: i ? '1px solid #f0f0ee' : 'none', transition: 'background .15s' }}
                onMouseEnter={e => e.currentTarget.style.background = '#fafaf9'} onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={d.active ? '#22c55e' : '#c4c4c2'} strokeWidth="2" strokeLinecap="round" style={{ flexShrink: 0 }}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 14, fontWeight: 600, color: '#0a0a0a' }}>{d.title}</div>
                  <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{d.content?.slice(0, 80)}{(d.content?.length || 0) > 80 ? '...' : ''}</div>
                </div>
                <span className="sett-tag" style={{ flexShrink: 0 }}>{d.category}</span>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexShrink: 0 }}>
                  <button className="sett-btn sett-btn-ghost" style={{ height: 34, padding: '0 14px', fontSize: 12 }} onClick={() => setKbEdit({ id: d.id, title: d.title, content: d.content, category: d.category || 'general' })}>Editar</button>
                  <button className="sett-btn sett-btn-danger" style={{ height: 34, padding: '0 10px', fontSize: 12 }} onClick={() => deleteKbDoc(d.id)}>
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                  </button>
                  <button onClick={() => toggleKbDoc(d)} style={{ position: 'relative', width: 44, height: 26, borderRadius: 13, border: 'none', cursor: 'pointer', transition: 'background .2s', background: d.active ? '#22c55e' : '#e5e5ea', flexShrink: 0 }}>
                    <span style={{ position: 'absolute', top: 2, left: d.active ? 20 : 2, width: 22, height: 22, borderRadius: '50%', background: '#fff', transition: 'left .2s', boxShadow: '0 1px 3px rgba(0,0,0,.2)' }}/>
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* MODAL: CREAR/EDITAR DOCUMENTO */}
      {kbEdit && (
        <div className="sett-modal-overlay" onClick={e => { if (e.target === e.currentTarget) setKbEdit(null); }}>
          <div className="sett-modal" style={{ width: 620, maxHeight: '90vh', overflow: 'auto' }}>
            <div style={{ padding: '24px 28px 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ fontSize: 20, fontWeight: 700, color: '#0a0a0a', letterSpacing: '-.3px' }}>{kbEdit.id ? 'Editar documento' : 'Nuevo documento'}</div>
              <button className="sett-btn sett-btn-ghost" style={{ width: 32, height: 32, padding: 0, borderRadius: '50%', justifyContent: 'center' }} onClick={() => setKbEdit(null)}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
            <div style={{ padding: '20px 28px 28px' }}>
              <div style={{ marginBottom: 16 }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: '#0a0a0a', marginBottom: 6 }}>Título</div>
                <input className="sett-input" placeholder="Ej: Política de garantías" value={kbEdit.title} onChange={e => setKbEdit({ ...kbEdit, title: e.target.value })} />
              </div>
              <div style={{ marginBottom: 16 }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: '#0a0a0a', marginBottom: 6 }}>Categoría</div>
                <select className="sett-select" style={{ width: '100%' }} value={kbEdit.category} onChange={e => setKbEdit({ ...kbEdit, category: e.target.value })}>
                  <option value="general">General</option>
                  <option value="garantias">Garantías</option>
                  <option value="envios">Envíos</option>
                  <option value="productos">Productos</option>
                  <option value="pagos">Pagos</option>
                  <option value="faq">Preguntas frecuentes</option>
                </select>
              </div>
              <div style={{ marginBottom: 20 }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
                  <div style={{ fontSize: 12, fontWeight: 600, color: '#0a0a0a' }}>Contenido</div>
                  <div style={{ fontSize: 11, color: '#9ca3af' }}>{kbEdit.content.length} caracteres</div>
                </div>
                <textarea className="sett-input" placeholder="Escribe aquí la información que el agente debe conocer..." value={kbEdit.content} onChange={e => setKbEdit({ ...kbEdit, content: e.target.value })} style={{ height: 'auto', minHeight: 280, resize: 'vertical', padding: 14, lineHeight: 1.6, fontSize: 13 }} />
              </div>
              <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
                <button className="sett-btn sett-btn-ghost" onClick={() => setKbEdit(null)}>Cancelar</button>
                <button className="sett-btn sett-btn-primary" onClick={saveKbDoc} disabled={kbSaving || !kbEdit.title.trim() || !kbEdit.content.trim()}>{kbSaving ? 'Guardando...' : kbEdit.id ? 'Guardar cambios' : 'Crear documento'}</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
